import { cookies } from '@/lib/jucyCookies';

export const hasLocaleSet = () => {
    return Boolean(cookies.get('NEXT_LOCALE'));
};
